module.exports = __webpack_public_path__ + "static/media/Mareike Lühring.0ce2b299.png";